enum EventTabEnum {
  Overview,
  Agenda,
  Speakers,
  Sponsors,
}

export default EventTabEnum;
